<template>
  <main class="articles">
    <div class="articles__container">
      <div class="articles__first first-article">
        <router-link
          class="first-article__container"
          tag="div" 
          :to="{ name: 'Article', params: { id: articles[0].id }}"
        >
          <img class="first-article__image" :src="articles[0].preview.url" :alt="articles[0].previewText">
          <div class="first-article__overlay"></div>
          <pre class="first-article__title">{{ articles[0].previewText }}</pre>
        </router-link>
      </div>
      <div class="articles__second second-article">
        <router-link
          class="second-article__container"
          tag="div"
          :to="{ name: 'Article', params: { id: articles[1].id }}"
        >
          <img class="second-article__image" :src="articles[1].preview.url" :alt="articles[1].previewText">
          <div class="second-article__overlay"></div>
          <pre class="second-article__title">{{ articles[1].previewText }}</pre>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
import { apiGetAllArticles } from '../utils/api' 
import { CHANGE_CLIENT_ARTICLES } from '../store/mutations-names'

export default {
  name: 'Articles',
  data() {
    return {
      isLoading: true,
      articles: [
        {
          id: 1,
          previewText: '',
          preview: { url: null, filePath: '' }
        },
        {
          id: 2,
          previewText: '',
          preview: { url: null, filePath: '' }
        }
      ]
    }
  },
  async mounted() {
    if (this.$store.state.clientArticles.length) {
      this.articles = this.$store.state.clientArticles
      return
    } else {
      // load articles and store them in store
      try {
        this.articles = await apiGetAllArticles()
        this.$store.commit(CHANGE_CLIENT_ARTICLES, this.articles)
      } catch(e) {
        console.error(e.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.articles {
  display: flex;
  justify-content: center;
  padding: 35px 100px 0;
  &__container {
    display: grid;
    grid-template-columns: auto auto;
    flex-shrink: 0;
    max-width: 100%;
  }
  &__first {
    padding: 40px 60px 0 0;
  }
}

.first-article {
  @include fonts.ap-reg;
  font-size: 20px;
  line-height: 24px;
  &__container {
    position: relative;
    height: 100%;
    cursor: pointer;
  }
  &__container:hover &__overlay {
    opacity: 0.4;
  }
  &__image {
    height: 54vh;
    margin-bottom: 10px;
    object-fit: cover;
    background-color: colors.$grayef;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 54vh;
    background-color: #000;
    opacity: 0;
    transition: 200ms opacity ease;
  }
}

.second-article {
  @include fonts.ap-reg;
  font-size: 20px;
  line-height: 26px;
  &__container {
    position: relative;
    height: 100%;
    cursor: pointer;
  }
  &__container:hover &__overlay {
    opacity: 0.4;
  }
  &__image {
    height: 69vh;
    margin-bottom: 10px;
    object-fit: cover;
    background-color: colors.$grayef;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 69vh;
    box-sizing: border-box;
    background-color: #000;
    opacity: 0;
    transition: 200ms opacity ease;
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait){
  .articles {
    padding: 15px 100px 50px;
    &__container {
      grid-template-columns: 1fr;
      row-gap: 25px;
    }
    &__first {
      padding: 0;
    }
  }
  .first-article {
    &__image {
      width: 100%;
      height: auto;
    }
    &__overlay {
      display: none;
    }
  }
  .second-article {
    &__image {
      width: 100%;
      height: auto;
    }
    &__overlay {
      display: none;
    }
  }
}

@media screen and (max-width: 767px) {
  .articles {
    padding: 15px 12px 50px;
  }
  .first-article__title, .second-article__title {
    font-size: 18px;
    line-height: normal;
  }
}
@media screen and (max-width: 767px) and (orientation: landscape) {
  .articles {
    padding: 15px 12px 0;
  }
  .first-article__title, .second-article__title {
    font-size: 18px;
    line-height: normal;
  }
}

</style>